import { Button, Typography } from '@material-ui/core';
import { FormEvent, useEffect, useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from '../../../../contexts/snackbar';
import { axiosCallHandler } from '../../../../infra/axiosHelper';
import { FSetSnackbarProps } from '../../types';
import CustomAutoComplete from '../components/CustomAutoComplete';
import { Reducer } from './reducer';
import * as S from './styles';

export function CreatePraca() {
  const snackbar = useSnackbar();
  const history = useHistory();
  const [localStateValues, localDispatch] = useReducer(Reducer, {
    list: [],
    current: { name: '', label: '' },
    label: '',
    name: '',
  });

  const [channelStateValues, channelDispatch] = useReducer(Reducer, {
    list: [],
    current: { name: '', label: '' },
    label: '',
    name: '',
  });

  const isLocalDisabled =
    localStateValues.label === '' || localStateValues.name === '';

  const isChannelDisabled =
    channelStateValues.label === '' || channelStateValues.name === '';

  function setSnackbar({ status, type, message }: FSetSnackbarProps) { 
    snackbar.setStatus(status);
    snackbar.setType(type);
    snackbar.setMessage(message);
  }

  function handleCreateLocal(event: FormEvent) {
    event.preventDefault();

    const { label, name } = localStateValues;

    axiosCallHandler({
      method: 'POST',
      url: `/locations`,
      data: { name, label },
    }).then(() => {
      setSnackbar({
        status: true,
        message: `O campo ${localStateValues.label} foi salvo com sucesso!`,
        type: 'success',
      });

      localDispatch({ type: 'CLEAR_ALL' });
    });
  }

  function handleCreateChannel(event: FormEvent) {
    event.preventDefault();

    const { label, name } = channelStateValues;

    axiosCallHandler({
      method: 'POST',
      url: `/channels`,
      data: { name, label },
    }).then(() => {
      setSnackbar({
        status: true,
        message: `O campo ${channelStateValues.label} foi salvo com sucesso!`,
        type: 'success',
      });

      channelDispatch({ type: 'CLEAR_ALL' });
    });
  }

  //Local management methods
  const handleSetLocalCurrent = (localCurrent: any) => {
    localDispatch({ type: 'SET_CURRENT', payload: localCurrent });
  };

  const handleSetLocalLabel = (localLabel: string) => {
    localDispatch({ type: 'SET_LABEL', payload: localLabel });
  };

  const handleSetLocalName = (localName: string) => {
    localDispatch({ type: 'SET_NAME', payload: localName });
  };

  //Channel management methods
  const handleSetChannelCurrent = (channelCurrent: any) => {
    channelDispatch({ type: 'SET_CURRENT', payload: channelCurrent });
  };

  const handleSetChannelLabel = (channelLabel: string) => {
    channelDispatch({ type: 'SET_LABEL', payload: channelLabel });
  };

  const handleSetChannelName = (channelName: string) => {
    channelDispatch({ type: 'SET_NAME', payload: channelName });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const locations = await axiosCallHandler({
          method: "GET",
          url: "/clipping-sources/locations",
        });
  
        if (locations?.redirect) {
          history.push("/login");
          return;
        }
  
        localDispatch({ type: "SET_LIST", payload: locations });
  
        const channels = await axiosCallHandler({
          method: "GET",
          url: "/clipping-sources/channels",
        });
  
        channelDispatch({ type: "SET_LIST", payload: channels });
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
  
    fetchData();
  }, []);

  return (
    <S.Container>
      <Typography variant="h5">Adicionar novo local</Typography>
      <S.FormWrapper onSubmit={handleCreateLocal}>
        <CustomAutoComplete
          options={localStateValues.list}
          label="Label"
          setValue={handleSetLocalCurrent}
          value={localStateValues.current}
          setInputValue={handleSetLocalLabel}
          gridArea="label"
        />
        <CustomAutoComplete
          options={localStateValues.list}
          label="Sigla"
          setValue={handleSetLocalCurrent}
          value={localStateValues.current}
          nameType
          setInputValue={handleSetLocalName}
          gridArea="name"
        />
        <Button
          type="submit"
          variant="contained"
          disableRipple
          disabled={isLocalDisabled}
        >
          Salvar
        </Button>
      </S.FormWrapper>

      <hr />

      <Typography variant="h5">Adicionar novo canal</Typography>

      <S.FormWrapper onSubmit={handleCreateChannel}>
        <CustomAutoComplete
          options={channelStateValues.list}
          label="Label"
          setValue={handleSetChannelCurrent}
          value={channelStateValues.current}
          setInputValue={handleSetChannelLabel}
          gridArea="label"
        />
        <CustomAutoComplete
          options={channelStateValues.list}
          label="Sigla"
          setValue={handleSetChannelCurrent}
          value={channelStateValues.current}
          nameType
          setInputValue={handleSetChannelName}
          gridArea="name"
        />
        <Button
          type="submit"
          variant="contained"
          disabled={isChannelDisabled}
          disableRipple
        >
          Salvar
        </Button>
      </S.FormWrapper>
    </S.Container>
  );
}
